import { Component, input } from '@angular/core';
import { CalendarEvent } from '../../../../core/models/ordering/calendar-event.model';
import { CommonModule } from '@angular/common';
import { ExpandableComponent } from '../../../expandable-component/expandable.component';
import { DateFormatPipe } from '../../../../core/pipes/date-format.pipe';
import { IconNameType } from '../../../icons/icon-name-type.enum';
import { IconComponent } from '../../../icons/icon.component';
import { rotate } from '../../../animations/animations';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'cwo-calendar-event',
  standalone: true,
  imports: [CommonModule, ExpandableComponent, DateFormatPipe, IconComponent, TranslocoPipe],
  templateUrl: './calendar-event.component.html',
  styleUrl: './calendar-event.component.scss',
  animations: [rotate('-180deg')],
})
export class CalendarEventComponent {
  calendarEvent = input.required<CalendarEvent>();

  isExpanded = false;
  iconNameType = IconNameType;

  handleExpanded(isExpanded: boolean) {
    this.isExpanded = isExpanded
  }
}
